import { Component, OnInit } from '@angular/core';
import { ExcelViewerService } from '../../service/excel-viewer.service';
import { ToplineService } from '../../service/topline.service';
import { NotifierService } from 'angular-notifier';
import { RepoApiService } from '../../service/repo-api.service';


@Component({
  selector: 'app-group-table',
  templateUrl: './group-table.component.html',
  styleUrls: ['./group-table.component.scss']
})
export class GroupTableComponent implements OnInit {
  public selectTabSheetIndex:number;
  public groupName:string;
  public tableListBasedOnSelectedSheet:any = [];
  public selectedTable:any = [];
  public currentSelectedSheetId:any;
  public selectedKpis:any = {};
  public group:any= {};
  public showingTableList:boolean = false;
  constructor(
    public eService:ExcelViewerService,
    public toplineService:ToplineService,
    public notifier:NotifierService,
    private repoService:RepoApiService,
  ) { }

  ngOnInit(): void {
    this.setSelectedSheetIndex();
    this.setTableListBasedOnSelectedIndex();
  }

  setSelectedSheetIndex(){
    this.selectTabSheetIndex = this.eService.currentOpeningSheetIndex;
    // console.log(this.eService.selectSheet,this.eService.allFilters);
  }


  ngAfterViewInit(): void{
    document.querySelector('.selected-tab').scrollIntoView({inline:'center'});
  }

  


  setTableListBasedOnSelectedIndex(){
    this.selectedKpis = {};
    this.tableListBasedOnSelectedSheet = [];
    this.selectedTable = [];
    this.showingTableList = false;
    if(Object.values(this.eService.allFilters)[this.selectTabSheetIndex]['kpis']){
      this.selectedKpis= Object.values(this.eService.allFilters)[this.selectTabSheetIndex]['kpis'];
      this.currentSelectedSheetId = Object.values(this.eService.allFilters)[this.selectTabSheetIndex]['sheet_id'];
    }
    // console.log("this.selectedKpis ====> ",this.selectedKpis)
    if(Object.keys(this.selectedKpis).length){
      Object.keys(this.selectedKpis).forEach((va) =>{
        let obj = {
          id:this.selectedKpis[va]['table_id'],
          type:this.selectedKpis[va]['type'],
          name:this.selectedKpis[va]['name'],
          label:va,
          options:this.selectedKpis[va]['options']
        };
        this.tableListBasedOnSelectedSheet.push(obj);
      })
    }
  }


  ngOnDestroy(){
    this.closeToplineGroupTable();
  }




  closeToplineGroupTable(){
    this.eService.isToplineGroupTableComponent = false;
    this.tableListBasedOnSelectedSheet = [];
    this.selectedKpis = {};
  }


  movingArrow(type:string){
    if(type=='left'){
      if(this.selectTabSheetIndex <= 0){
        this.selectTabSheetIndex = 0;
      }else{
        this.selectTabSheetIndex -= 1;
      }

    }else{
      if(this.selectTabSheetIndex >= this.eService.allSheetsName.length-1){
        this.selectTabSheetIndex = this.eService.allSheetsName.length-1;
      }else{
        this.selectTabSheetIndex += 1;
      }
    }
    this.setTableListBasedOnSelectedIndex();
    document.querySelector('.selected-tab').scrollIntoView({inline:'center'});
  }


  setSelectedTabIndex(ind:number){
    this.selectTabSheetIndex = ind;
    this.setTableListBasedOnSelectedIndex();
  }

  getSelectedTableName(params,len){
    let name = "";
    if(params == 'table'){
      this.selectedTable.forEach((va) =>{
        name += va['name'];
        name += ',';
      })
      if(name.length > len){
        return name.substring(0,len) + '....';
      }
      return name.substring(0,name.length-1);
    }
  }





 


 



  onSave(){
    if(this.validateForm()){
      let body = {};
      body['name'] = this.groupName;
      body['file_id'] = this.toplineService.excelviewer_fileUUID;
      body['sheet_id'] = this.currentSelectedSheetId
      body['selected_tables'] = [];
      if (this.eService.lastKpi  && this.eService.lastKpi.priority != null && this.eService.lastKpi.priority >= 0) {
        body['priority'] = this.eService.lastKpi.priority + 1;
      }
      this.selectedTable.forEach((va) =>{
        let obj = {};
        obj['id'] = va['id'];
        obj['name'] = va['name'];
        obj['label'] = va['label'];
        body['selected_tables'].push(obj);
      })

      this.repoService.groupTableInKpis(body).subscribe((res) =>{
        if(res['status'] == 1){
          this.closeToplineGroupTable();
          // this.eService.isResetPriorityneeded = true;
          this.eService.refreshFilterOptions();
          let parent_id = res["parent_id"];
          this.eService.kpiParentId = parent_id.split("$_$-$_$");
          // this.eService.getFilterOptions();
        }else{
          this.notifier.notify('error','Something Went Wrong')
        }
      })

    }
  }






  validateForm(){
    if(!this.groupName || this.groupName == ''){
      this.notifier.notify('error','Please Enter Group Name');
      return 0;
    }
    if(this.selectedTable.length === 0){
      this.notifier.notify('error','Please select table to group');
      return 0;
    }else{
      return 1;
    }
  }


 


  showingTableListComponent(){
    this.showingTableList = !this.showingTableList;
  }


  addtoTableInGroup(table:any){
    let exitTable = this.selectedTable.findIndex((va) =>{
      return va['id'] === table['id'];
    })
    if(exitTable === -1){
      this.selectedTable.push(table);
    }else{
      this.selectedTable.splice(exitTable,1);
    }
  }


  checkedOrNot(table){
    let exitTable = this.selectedTable.findIndex((va) =>{
      return va['id'] === table['id'];
    })
    return exitTable === -1 ? false : true;

  }




}
